import { Typography } from '@euler/app/components/typography';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { roleNameFromRoleType } from '@euler/functions/user/util';
import {
  CoachingSuggestionReason,
  CoachingSuggestionReasonKind,
} from '@euler/model/coaching';
import { BookOpen, IdCard, Target } from 'lucide-react-native';
import { memo } from 'react';
import { View } from 'react-native';

/** Why a case is suggested, in one line. */
export const SuggestionReason = memo(
  ({ reason }: { reason: CoachingSuggestionReason }) => {
    const { rpx } = useResponsiveContext();
    const Icon =
      reason.kind === CoachingSuggestionReasonKind.CollectionNext
        ? BookOpen
        : reason.kind === CoachingSuggestionReasonKind.WeakestArea
        ? Target
        : IdCard;
    const text =
      reason.kind === CoachingSuggestionReasonKind.CollectionNext
        ? `「${reason.collection.name}」合集的下一课`
        : reason.kind === CoachingSuggestionReasonKind.WeakestArea
        ? `你的「${reason.area.name}」偏弱，练练「${reason.criterion.name}」`
        : `适合你的岗位：${roleNameFromRoleType(reason.role)}`;
    return (
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          gap: rpx(6),
          marginTop: rpx(12),
          borderRadius: rpx(8),
          paddingHorizontal: rpx(10),
          paddingVertical: rpx(8),
          backgroundColor: aiColors.muted,
        }}
      >
        <Icon size={rpx(14)} color={aiColors.mutedForeground} />
        <Typography.Text size={rpx(11)} color={aiColors.mutedForeground}>
          {text}
        </Typography.Text>
      </View>
    );
  },
);
